<template>
    <tr>
        <!--<td>
            <v-checkbox
                    primary
                    hide-details
                    v-model="selected"
            ></v-checkbox>
        </td>-->
        <td class="text-xs-right" @click="expand">{{ item.name +' '+item.lastname }}</td>
        <td class="text-xs-right" @click="expand">{{ item.unidad ? item.unidad: item.rama }}</td>
        <td class="text-xs-right" @click="expand">{{ item.birthday }}</td>
        <td class="text-xs-right" @click="expand">{{ item.days.join(' ') }}</td>
        <td class="text-xs-right" @click="expand">{{ item.bus.join(' ') }}</td>
        <td class="text-xs-right" @click="expand">{{ item.alergias || '' }}</td>
        <td class="text-xs-right red--text" >
            <v-menu offset-y>
                <v-btn small :color="item.status === 'Completed' ? 'green' : 'red'" flat slot="activator" >
                    {{item.status}}
                </v-btn>
                <v-card>
                <v-list>
                    <v-list-tile @click="setStatus('Completed')" >
                        <v-list-tile-title>Completos</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="setStatus('Missing')" >
                        <v-list-tile-title>Faltan</v-list-tile-title>
                    </v-list-tile>
                </v-list>
                </v-card>
            </v-menu>
        </td>
        <td @click="(event) => event.preventDefault()" class="text-xs-right">
            <v-dialog v-model="dialog" persistent max-width="290">
                <v-btn slot="activator" icon class="mx-0" >
                <v-icon color="pink">delete</v-icon>
            </v-btn>
                <v-card>
                    <v-card-title class="headline">Borrar esta información</v-card-title>
                    <v-card-text>¿Estás seguro de que quieres eliminar esta información? Esta acción es irreversible y no se borrarán los datos de la reserva</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat @click="deleteItem">Borrar</v-btn>
                        <v-btn color="grey darken-1" flat @click="dialog = false">Cancelar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </td>
        <v-snackbar
                :timeout="600"
                bottom right
                v-model="snackbar"
        >
            {{ text }}
            <v-btn flat color="orange" @click.native="snackbar = false">Cerrar</v-btn>
        </v-snackbar>

    </tr>
</template>

<script>
    export default {
        props: ['item', 'selected'],
        name: "item-table",
        data() {
           return {
              menu: false,
              snackbar: null,
              text: '',
              dialog: false
           }
        },
        methods: {
            expand() {
                this.$emit("expand")
            },
            setStatus (text) {
                var status = this.item.status
                this.item.status = text
                var vue = this
                this.$db.collection('forms').doc('inscripciones').collection('people').doc(this.item.id).update({
                    status: text
                }).then(function () {
                    vue.snackbar = true
                    vue.text = 'Cambios guardados'
                }).catch(function (error) {
                    vue.item.status = status
                    vue.snackbar  = true
                    vue.text =  'ERROR: No se han guardado los cambios'
                    console.error("Error writing document: ", error);
                })
            },
            openRecipe(e){
                this.$storage.ref().child(this.item.recipe).getDownloadURL().then(function(url) {
                    window.open(url)
                }).catch(function(error) {
                    // Handle any errors
                });
                console.log(this.item.recipe)
                e.preventDefault()
            },
            deleteItem(){
                var vue = this
                this.dialog = false
                this.$db.collection('forms').doc('inscripciones').collection('people').doc(this.item.id).delete().then(function() {
                    vue.snackbar = true
                    vue.text = `Eliminado ${vue.item.id}`
                   // vue.$emit('delete')
                }).catch(function(error) {
                    console.log(error)
                    vue.snackbar = true
                    vue.text = `Error eliminando reserva`
                });
            }
        }

    }
</script>

<style scoped>
    .Completed {
        color: darkgreen;
    }
</style>